import { GetPrescribedBurnsModel, S3HazardsDataSource } from '@/features/hazards';

export class MockS3HazardsDataSource implements S3HazardsDataSource {
  async getPrescribedBurns(): Promise<GetPrescribedBurnsModel> {
    return { type: 'FeatureCollection', features: [] };
  }
}
